import { RoadMapUpdate } from '@/domain/roadmap/types';
import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { Control, Controller } from 'react-hook-form';

import { FieldActionsWrapper } from './shared/FieldActionsWrapper';

interface ExternalOriginFieldProps {
  viewOnly: boolean;
  control: Control<RoadMapUpdate, unknown>;
  required: boolean;
}

export function ExternalOriginField({ viewOnly, control, required }: Readonly<ExternalOriginFieldProps>) {
  return (
    <Controller
      name="externalOrigin"
      control={control}
      rules={{ required }}
      render={({ field, fieldState: { error } }) => (
        <Box sx={{ py: 0.75, width: '100%' }}>
          <FieldActionsWrapper copyValue={field.value ?? ''}>
            <TextField
              {...field}
              label="External Origin / MOCX"
              required={required}
              disabled={viewOnly || !required}
              fullWidth
              size="small"
              slotProps={{ htmlInput: { maxLength: 255 } }}
              error={!!error}
              helperText={error ? 'Required' : undefined}
            />
          </FieldActionsWrapper>
        </Box>
      )}
    />
  );
}
